<div class="heading">{{ item?.header ?? 'WALLET' }}</div>
<div class="cont">
  <div class="status-wrap">
    <i [ngClass]="item?.status == 'success' ? 'fi-check-circle success' : 'fi-x-circle fail'"></i>
    <div class="title">{{ item?.title }}</div>
    <div class="text">{{ item?.content }}</div>
  </div>
  @if (item?.data) {
    <div class="detail-wrap">
      <div class="top">
        <div class="typeTitle">{{ item?.typeTitle }}</div>
        <!-- 後端回傳的amount已經減去平台手續費了，所以要呈現完成提款金額要把平台手續費加回來 -->
        @if (item?.data.amount) {
          <span class="amount">
            @if (item?.data.fee) {
              {{ item?.data.amount.add(item?.data.fee) | currencyValue: item?.data.currency }} {{ item?.data.currency }}
            } @else {
              {{ item?.data.amount | currencyValue: item?.data.currency }} {{ item?.data.currency }}
            }
            <img class="currency-icon" [src]="item?.data.currency | currencyIcon"
          /></span>
        }
      </div>
      <div class="line"></div>
      <div class="list">
        @if (item?.orderStatus) {
          <div class="item">
            <span>Status</span>
            @if (item?.orderStatus == 'pending') {
              <span class="mark"> Pending </span>
            } @else if (item?.orderStatus == 'success') {
              <span class="total"> Success </span>
            } @else {
              <span class="error"> Fail </span>
            }
          </div>
        }
        @if (item?.data.orderId) {
          <div class="item">
            <span>ID</span>
            <span>{{ item?.data.orderId }}</span>
          </div>
        }
        @if (item?.data.cryptoOrderId) {
          <div class="item">
            <span>ID</span>
            <div class="flex-item">
              <span>{{ item?.data.cryptoOrderId }}</span>
              <span class="copy-btn" (click)="walletService.copy(item?.data.cryptoOrderId, 'Copied Order Id')">
                <i class="fi-clipboard"></i>
              </span>
            </div>
          </div>
        }
        @if (item?.data.fee !== undefined) {
          <div class="item">
            <span>Platform fee</span>
            <span class="mark"
              >-{{ item?.data.fee ?? 0 | currencyValue: item?.data.currency }} {{ item?.data.currency
              }}<img class="currency-icon" [src]="item?.data.currency | currencyIcon"
            /></span>
          </div>
        }
        @if (item?.data.coinFee !== undefined) {
          <div class="item">
            <span>Network fee</span>
            <span class="mark"
              >-{{ item?.data.coinFee ?? 0 | currencyValue: item?.data.currency }} {{ item?.data.currency
              }}<img class="currency-icon" [src]="item?.data.currency | currencyIcon"
            /></span>
          </div>
        }
        <!-- 後端回傳的amount已經減去平台手續費了 -->
        @if (item?.data.amount !== undefined) {
          <div class="item">
            <span>Received Amount</span>
            <span class="total">
              {{ receivedAmount | currencyValue: item?.data.currency }}
              {{ item?.data.currency }}<img class="currency-icon" [src]="item?.data.currency | currencyIcon" />
            </span>
          </div>
        }
        @if (item?.data.hashMsg) {
          <div class="item">
            <span>TXN Hash</span>
            <span class="copy-btn" (click)="walletService.copy(item?.data.hashMsg, 'Copied TXN Hash')">
              {{ walletService.shortenAddress(item?.data.hashMsg) }}
              <i class="fi-clipboard"></i>
            </span>
          </div>
        }
      </div>
      <cs-button
        (buttonClick)="jumpToTransactions(item?.typeTitle == 'Deposit' ? 'deposit' : 'withdrawal')"
        label="Go to Transactions"
        color="secondary"
        size="small"
      ></cs-button>
    </div>
  }
  <cs-button (buttonClick)="close()" label="Close" color="accent" size="large"></cs-button>
</div>
